import { Controller } from '@hotwired/stimulus';

// Handles drag-and-drop file uploads by forwarding dropped files
// to a connected file input element via an outlet.
export default class extends Controller {
  static outlets = ['input'];
  dragDepth = 0;

  connect() {
    this.element.addEventListener('dragenter', this.onDragEnter);
    this.element.addEventListener('dragover', this.onDragOver);
    this.element.addEventListener('dragleave', this.onDragLeave);
    this.element.addEventListener('drop', this.onDrop);
  }

  disconnect() {
    this.element.removeEventListener('dragenter', this.onDragEnter);
    this.element.removeEventListener('dragover', this.onDragOver);
    this.element.removeEventListener('dragleave', this.onDragLeave);
    this.element.removeEventListener('drop', this.onDrop);
  }

  onDragEnter = (event) => {
    event.preventDefault();
    this.dragDepth += 1;
    this.element.classList.add('border-primary', 'bg-primary-subtle');
  };

  onDragOver = (event) => {
    event.preventDefault();
  };

  onDragLeave = (event) => {
    event.preventDefault();
    this.dragDepth = Math.max(0, this.dragDepth - 1);
    if (this.dragDepth === 0) {
      this.element.classList.remove('border-primary', 'bg-primary-subtle');
    }
  };

  onDrop = (event) => {
    event.preventDefault();
    this.dragDepth = 0;
    this.element.classList.remove('border-primary', 'bg-primary-subtle');

    const fileInput = this.element.querySelector('input[type="file"]');
    if (fileInput && event.dataTransfer.files.length > 0) {
      fileInput.files = event.dataTransfer.files;
      fileInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };
}
